/* ALCAMI LATTE: behaviour for the Smart Latte page sections (sections/alcami-latte-*).
   Reveal on scroll, count-up numbers, the ingredient cup, customer video reels,
   the founder video modal, the "what to expect" timeline, and buttons that scroll to
   (and pick a flavour in) the buy box. */
(function () {
  if (window.__alat) return;
  window.__alat = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var each = function (root, sel, fn) { [].forEach.call(root.querySelectorAll(sel), fn); };

  /* ---------- reveal + count ---------- */
  var countUp = function (el) {
    var m = (el.getAttribute('data-alat-count') || el.textContent).trim().match(/^([^\d]*)(\d+(?:[.,]\d+)?)([^\d]*)$/);
    if (!m || reduce) return;
    var end = parseFloat(m[2].replace(',', '.'));
    if (!(end >= 2)) return;
    var dec = (m[2].split(/[.,]/)[1] || '').length, sep = m[2].indexOf(',') > -1 ? ',' : '.';
    var t0 = null, dur = 1400;
    var step = function (t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = m[1] + (end * e).toFixed(dec).replace('.', sep) + m[3];
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      e.target.classList.add('is-in');
      each(e.target, '[data-alat-count]', countUp);
      if (e.target.hasAttribute('data-alat-count')) countUp(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px' }) : null;
  var watch = function (root) {
    each(root, '[data-alat-reveal]', function (el) { if (io) io.observe(el); else el.classList.add('is-in'); });
  };

  /* ---------- buy box ---------- */
  var buyBox = function () {
    return document.querySelector('[id*="alcami_elements_with_triple_kit"]') ||
      document.querySelector('main .shopify-section');
  };
  var headerH = function () {
    var h = document.querySelector('sticky-header, .header-wrapper, .shopify-section-header-sticky, header');
    var r = h && h.getBoundingClientRect();
    return r && r.bottom > 0 ? Math.min(r.height, 140) : 0;
  };
  var pickFlavour = function (letter) {
    var box = buyBox();
    if (!box || !letter) return false;
    var labels = [].filter.call(box.querySelectorAll('label'), function (l) { return l.offsetParent !== null; });
    for (var i = 0; i < labels.length; i++) {
      var inp = labels[i].querySelector('input[type="radio"]') || (labels[i].htmlFor && document.getElementById(labels[i].htmlFor));
      if (!inp || !/(single-flavour|flavour1)$/.test(inp.name)) continue;
      var m = inp.value.match(/_[sdt]([oemc])\d?$/);
      if (m && m[1] === letter) { labels[i].click(); return true; }
    }
    return false;
  };
  var toBuy = function (letter) {
    var box = buyBox();
    if (letter) pickFlavour(letter);
    if (!box) { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); return; }
    var y = box.getBoundingClientRect().top + window.pageYOffset - headerH() - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
  };

  /* ---------- cup ---------- */
  var cup = function (root) {
    each(root, '[data-alat-cup]', function (c) {
      if (c.__alat) return; c.__alat = true;
      var tabs = [].slice.call(c.querySelectorAll('[data-alat-layer]'));
      var panels = [].slice.call(c.querySelectorAll('[data-alat-panel]'));
      var show = function (i, focus) {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
        if (focus) tabs[i].focus();
        c.setAttribute('data-alat-active', i);
      };
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = tabs.length;
          if (k === 'ArrowDown' || k === 'ArrowRight') { e.preventDefault(); show((i + 1) % n, true); }
          if (k === 'ArrowUp' || k === 'ArrowLeft') { e.preventDefault(); show((i - 1 + n) % n, true); }
        });
      });
      each(c, '[data-alat-cupnext]', function (b) {
        b.addEventListener('click', function () {
          var i = +(c.getAttribute('data-alat-active') || 0), d = +b.getAttribute('data-alat-cupnext');
          show((i + d + tabs.length) % tabs.length);
        });
      });
      show(0);
    });
  };

  /* ---------- reels ---------- */
  var playing = null;
  var stop = function (card) {
    if (!card) return;
    var v = card.querySelector('video');
    if (v) v.pause();
    card.classList.remove('is-playing');
    if (playing === card) playing = null;
  };
  var reels = function (root) {
    each(root, '[data-alat-reels]', function (r) {
      if (r.__alat) return; r.__alat = true;
      var track = r.querySelector('[data-alat-track]');
      each(r, '[data-alat-reel]', function (card) {
        var v = card.querySelector('video'), btn = card.querySelector('[data-alat-play]'), snd = card.querySelector('[data-alat-sound]'), bar = card.querySelector('.alat-reel__bar i');
        if (!v || !btn) return;
        btn.addEventListener('click', function () {
          if (playing === card) { stop(card); return; }
          stop(playing);
          if (!v.getAttribute('src') && v.dataset.src) { v.src = v.dataset.src; }
          v.muted = false; card.classList.remove('is-muted');
          var p = v.play();
          if (p && p.catch) p.catch(function () { v.muted = true; card.classList.add('is-muted'); v.play().catch(function () {}); });
          card.classList.add('is-playing', 'is-started');
          playing = card;
        });
        if (snd) snd.addEventListener('click', function (e) {
          e.stopPropagation();
          v.muted = !v.muted;
          card.classList.toggle('is-muted', v.muted);
        });
        v.addEventListener('timeupdate', function () { if (bar && v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%'; });
        v.addEventListener('ended', function () { stop(card); v.currentTime = 0; });
      });
      each(r, '[data-alat-scroll]', function (b) {
        b.addEventListener('click', function () {
          var card = track.querySelector('[data-alat-reel]');
          var w = card ? card.getBoundingClientRect().width + 18 : 280;
          track.scrollBy({ left: w * +b.getAttribute('data-alat-scroll'), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting && playing && r.contains(playing)) stop(playing); }); }, { threshold: 0 }).observe(r);
      }
    });
  };

  /* ---------- founder video modal ---------- */
  var modal = null;
  var closeModal = function () {
    if (!modal) return;
    modal.classList.remove('is-open');
    var box = modal.querySelector('.alat-modal__box iframe');
    if (box) box.remove();
    document.documentElement.style.overflow = '';
    if (modal.__from) modal.__from.focus();
  };
  var openModal = function (id, from) {
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'alat-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Video');
      modal.innerHTML = '<div class="alat-modal__box"></div><button type="button" class="alat-modal__close" aria-label="Close video"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('.alat-modal__close')) closeModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    }
    stop(playing);
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    f.allowFullscreen = true;
    f.title = 'Video';
    modal.querySelector('.alat-modal__box').appendChild(f);
    modal.__from = from;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { modal.classList.add('is-open'); modal.querySelector('.alat-modal__close').focus(); });
  };

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-alat-to-buy]');
    if (b) { e.preventDefault(); toBuy(b.getAttribute('data-alat-to-buy')); return; }
    var y = e.target.closest && e.target.closest('[data-alat-yt]');
    if (y) { e.preventDefault(); openModal(y.getAttribute('data-alat-yt'), y); }
  });

  /* ---------- muted loop videos: load only when close to the screen ---------- */
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
        var p = v.play();
        if (p && p.then) p.then(function () { v.parentNode.classList.add('is-playing'); }).catch(function () {});
      } else if (v.getAttribute('src')) { v.pause(); }
    });
  }, { rootMargin: '300px 0px' }) : null;
  var lazyVideos = function (root) {
    each(root, '[data-alat-lazyvideo]', function (v) {
      if (v.__alat) return; v.__alat = true;
      v.muted = true;
      if (vio && !reduce) vio.observe(v);
    });
  };

  /* ---------- "what to expect" timeline ---------- */
  /* Phones: the caramel line fills as you scroll and each day lights up when its dot reaches
     60% of the screen height. Tablets and desktop: when the timeline comes into view the line
     draws across once and the days light up one after another. Styles: .alat-miles in alcami-latte.css. */
  var wide = window.matchMedia ? window.matchMedia('(min-width: 750px)') : { matches: true };
  var timelines = function (root) {
    each(root, '.alat-miles', function (list) {
      if (list.__alat) return; list.__alat = true;
      var miles = [].slice.call(list.querySelectorAll('.alat-mile'));
      if (!miles.length) return;
      list.classList.add('is-js');
      if (reduce) {
        list.classList.add('is-drawn');
        miles.forEach(function (m) { m.classList.add('is-lit'); });
        return;
      }
      var drawn = false;
      var draw = function () {
        if (drawn) return;
        drawn = true;
        list.classList.add('is-drawn');
        miles.forEach(function (m, i) { setTimeout(function () { m.classList.add('is-lit'); }, 150 + i * 380); });
      };
      var follow = function () {
        if (wide.matches) return;
        var r = list.getBoundingClientRect(), mark = window.innerHeight * 0.6;
        list.style.setProperty('--alat-tlpx', Math.max(0, Math.min(r.height - 24, mark - r.top - 12)).toFixed(1) + 'px');
        miles.forEach(function (m) { m.classList.toggle('is-lit', m.getBoundingClientRect().top + 14 <= mark); });
      };
      var mode = function () {
        list.classList.toggle('is-phone', !wide.matches);
        if (!wide.matches) { follow(); return; }
        list.style.removeProperty('--alat-tlpx');
        miles.forEach(function (m) { m.classList.toggle('is-lit', drawn); });
        var r = list.getBoundingClientRect();
        if (!drawn && r.top < window.innerHeight * 0.8 && r.bottom > 0) draw();
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting && wide.matches) draw(); });
        }, { threshold: 0.3 }).observe(list);
      }
      window.addEventListener('scroll', follow, { passive: true });
      window.addEventListener('resize', follow);
      if (wide.addEventListener) wide.addEventListener('change', mode);
      else if (wide.addListener) wide.addListener(mode);
      mode();
    });
  };

  var init = function (root) { watch(root); cup(root); reels(root); lazyVideos(root); timelines(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); each(e.target, '[data-alat-reveal]', function (el) { el.classList.add('is-in'); }); });
})();
